/* types.js */

"use strict";
/* global Slick */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const getDefaultCreateValue = require("../../../cellEditors/MapData/mapDataUtil");
const {
    Control: {
        Action: {Button},
    },
} = uiCore;

const formatters = require("../../../cellFormaters");
const mapDataFormatters = require("../../../cellFormaters/mapDataFormatters");
const mdCheckBoxEditor = require("../../../cellEditors/MapData/CheckBoxEditor");
const checkBoxEditor = require("../../../cellEditors/CheckBoxEditor");
const vendorEditor = require("../../../cellEditors/MapData/VendorEditor");
const netBoxDeviceTypeEditor = require("../../../cellEditors/MapData/NetBoxDeviceTypeEditor");
const skuEditor = require("../../../cellEditors/MapData/SkuEditor");

function createWithContext(context) {
    let ctx = context;
    let allGluSkus = {};
    ctx._isTypesDataValid = false;
    ctx._createTypesContent = function () {
        const slickTableTypesContainerMain = document.createElement("slick-table-cmdb-container");
        ctx._slickTableTypesContainer = document.createElement("slick-table-cmdb");
        ctx._addNewTypeRowButton = new Button({
            label: "Add Device Type +",
            active: true,
        });

        slickTableTypesContainerMain.appendChild(ctx._slickTableTypesContainer);

        const addRowButtonContainer = document.createElement("div");
        addRowButtonContainer.classList.add("add-new-rule-container");
        addRowButtonContainer.appendChild(ctx._addNewTypeRowButton._renderer._rootElem);
        slickTableTypesContainerMain.appendChild(addRowButtonContainer);

        ctx._slickTypesTable = undefined;
        ctx._maxSortOrderTypes = 0;

        ctx._columnsDeviceType = [
            {
                id: "order",
                width: 10,
                name: "",
                //field: "order",
                behavior: "selectAndMove",
                asyncPostRender: function (node) {
                    node[0].setAttribute("title", "Reorder");
                },
                selectable: false,
                resizable: false,
                cssClass: "cell-reorder dnd centered g-icon-drag",
                headerCssClass: "centered",
            },
            {
                id: "vendor",
                field: "vendor",
                width: 266,
                name: "Gluware Vendor",
                tooltip: "Vendor",
                resizable: false,
                formatter: mapDataFormatters.vendorFormatter,
                editor: vendorEditor,
            },
            {
                id: "regex",
                field: "regex",
                width: 90,
                name: "RegEx",
                tooltip: "RegEx",
                resizable: false,
                headerCssClass: "centered",
                formatter: mapDataFormatters.regexCheckboxFormatter,
                editor: mdCheckBoxEditor,
            },
            {
                id: "sku",
                field: "sku",
                width: 290,
                name: "Gluware SKU",
                tooltip: "Gluware SKU",
                resizable: false,
                editor: skuEditor,
                formatter: mapDataFormatters.skuFormatter,
            },
            {
                id: "create",
                field: "create",
                width: 90,
                name: "Create",
                tooltip: "Create",
                resizable: false,
                headerCssClass: "centered",
                formatter: formatters.checkboxFormatter,
                editor: checkBoxEditor,
            },
            {
                id: "netBoxDeviceType",
                field: "netBoxDeviceType",
                width: 290,
                name: "NetBox Device Type",
                tooltip: "NetBox Device Type",
                resizable: false,
                formatter: mapDataFormatters.netboxTypeFormatter,
                editor: netBoxDeviceTypeEditor,
            },
            {
                id: "deleteRow",
                width: 90,
                name: "Action",
                field: "deleteRow",
                selectable: false,
                resizable: false,
                cssClass: "cell-delete dnd centered",
                formatter: mapDataFormatters.deleteButtonFormatter,
                headerCssClass: "centered",
            },
        ];

        ctx._deviceTypeContainer.appendChild(slickTableTypesContainerMain);
        ctx._deviceTypeContainer.appendChild(
            ctx._dtCreateUnmappedCheckbox.renderer.getRootElement()
        );
        allGluSkus = ctx._getAvailableSortedValues(ctx.getGluSkus());
    };

    ctx.registerTypeListeners = function () {
        ctx._addNewTypeRowButton.on("UserClick", (ctx._onAddNewType = ctx._onAddNewType.bind(ctx)));
    };
    ctx.unregisterTypeListeners = function () {
        ctx._addNewTypeRowButton.removeAllListeners();
        ctx._unregisterTypesSlickTableListeners();
    };

    ctx._registerTypesSlickTableListeners = function () {
        if (ctx._slickTypesTable) {
            ctx._slickTypesTable.onCellChange.subscribe(ctx._onTypesCellChangeAction);
            ctx._slickTypesTable.onBeforeEditCell.subscribe(ctx._onBeforeEditCell);
            ctx._slickTypesTable
                .getContainerNode()
                .addEventListener("RowOrderChanged", ctx._onTypesRowsChanged);
        }
    };

    ctx._unregisterTypesSlickTableListeners = function () {
        if (ctx._slickTypesTable) {
            ctx._slickTypesTable.onCellChange.unsubscribe(ctx._onTypesCellChangeAction);
            ctx._slickTypesTable.onBeforeEditCell.unsubscribe(ctx._onBeforeEditCell);
            ctx._slickTypesTable
                .getContainerNode()
                .removeEventListener("RowOrderChanged", ctx._onTypesRowsChanged);
        }
    };

    ctx._resetTypeGrid = function (data) {
        if (!data) {
            data = ctx._getTypesGridData();
        }
        if (ctx._slickTypesDataView) {
            ctx._slickTypesDataView.setItems(data);
        }
        ctx._resetTypeGridView(data);
    };

    ctx._resetTypeGridView = function (data) {
        ctx._toggleNoDataPlaceholder(!data.length, ctx._slickTableTypesContainer);
        ctx._enableDisableAutoCreate(!data.length, ctx._dtCreateUnmappedCheckbox);
        // ctx._sortTable();
        if (ctx._slickTypesTable) {
            ctx._slickTypesTable.invalidate();
            ctx._slickTypesTable.render();
            ctx._slickTypesTable.resizeCanvas();
        }
    };

    ctx._renderTypesSlickGrid = function (data) {
        const typeData = data || ctx._getTypesGridData() || [];
        if (!ctx._slickTypesTable) {
            ctx._slickTableTypesContainer.style.height = (typeData.length + 1) * 80 + "px";
            ctx._slickTypesDataView = new Slick.Data.DataView();
            ctx._slickTypesDataView.setItems(typeData);
            ctx._slickTypesTable = new Slick.Grid(
                ctx._slickTableTypesContainer,
                ctx._slickTypesDataView,
                ctx._columnsDeviceType,
                ctx._tableOptions
            );

            ctx._registerTypesSlickTableListeners();
            // ctx._slickTypesTable.maxSortOrder = ctx._maxSortOrder;
            ctx._slickTypesTable.setSelectionModel(new Slick.RowSelectionModel());
            ctx._registerRowMovePlugin(ctx._slickTypesTable, ctx._slickTypesDataView);

            ctx._slickTableTypesContainer.appendChild(ctx._createNoDataPlaceholder());
            ctx._toggleNoDataPlaceholder(!typeData.length, ctx._slickTableTypesContainer);
            ctx._enableDisableAutoCreate(!typeData.length, ctx._dtCreateUnmappedCheckbox);
            ctx.registerTypeListeners();

            ctx._slickTableTypesContainer.style.height = "auto";
        } else {
            // ctx._resetTypesData(ctx._model._selectedClass);
            ctx._resetTypeGrid();
        }
    };

    ctx._getTypesGridData = function () {
        const data = ctx.getTypeMapping() || [];
        return data.map((item) => ctx._getTypeRow(item));
    };

    ctx._getTypeRow = function (item) {
        const metaData = ctx._metaData;
        const vendorOptions = ctx._vendorOptions;
        const nbDeviceTypeOptions = ctx._nbDeviceTypeOptions;
        const gluSkus = ctx.getGluSkus();
        let defaultVendor,
            defaultSku,
            defaultRegex = false,
            defaultNetBoxName,
            unAvailable = false,
            defaultNbType = nbDeviceTypeOptions[0] && nbDeviceTypeOptions[0].value;
        if (!item) {
            const vendorsList = Object.keys(gluSkus);
            for (let i = 0; i < vendorsList.length; i++) {
                const ven = vendorsList[i];
                const skuKeys = Object.keys(gluSkus[ven]);
                const keySet = skuKeys.some((key) => {
                    if (gluSkus[ven][key]) {
                        defaultSku = key;
                        defaultVendor = ven;
                        return true;
                    }
                });
                if (keySet) {
                    defaultNetBoxName = getDefaultCreateValue(
                        defaultVendor,
                        defaultSku,
                        vendorOptions,
                        [],
                        false
                    );
                    break;
                }
            }
            if (!defaultVendor) {
                defaultVendor = "ALL";
                defaultRegex = true;
                defaultSku = ".*";
                unAvailable = true;
                defaultNetBoxName = getDefaultCreateValue(defaultVendor, undefined, vendorOptions);
            }
            return {
                id: parseInt(Math.random() * 10000, 10),
                vendor: defaultVendor,
                regex: defaultRegex,
                sku: defaultSku,
                skuRegex: ".*",
                skuValue: defaultSku,
                create: false,
                netBoxDeviceType: defaultNbType,
                netBoxId: defaultNbType,
                netBoxName: defaultNetBoxName,
                isUnavailable: unAvailable,
                metaData,
                vendorOptions,
                nbDeviceTypeOptions,
                allGluSkus,
            };
        }

        defaultNetBoxName = getDefaultCreateValue(
            item.vendor,
            item.isRegEx ? undefined : item.sku,
            vendorOptions,
            [],
            false
        );

        return {
            id: item.id || Math.random() * 10000,
            vendor: item.vendor,
            regex: item.isRegEx,
            sku: item.sku,
            skuRegex: item.isRegEx ? item.sku : ".*",
            skuValue: item.isRegEx ? "" : item.sku,
            create: item.createMissing,
            netBoxDeviceType: item.netBoxId || item.netBoxName,
            netBoxId: item.netBoxId,
            netBoxName: item.netBoxName || defaultNetBoxName,
            metaData,
            vendorOptions,
            nbDeviceTypeOptions,
            allGluSkus,
        };
    };

    ctx._formatTypesGridToMapping = function (data) {
        const typesDataMapping = data.map((item) => {
            const typeObj = {};
            typeObj.vendor = item.vendor;
            typeObj.createMissing = item.create;
            typeObj.isRegEx = item.regex;
            typeObj.sku = item.sku;
            if (item.create) {
                typeObj.netBoxId = undefined;
                typeObj.netBoxName = item.netBoxName;
            } else {
                typeObj.netBoxId = item.netBoxId;
            }
            return typeObj;
        });
        return typesDataMapping;
    };

    let _validateRowData = function (data, item, idx) {
        if (!item) {
            return;
        }
        if (item.create && !item.netBoxName) {
            return false;
        }
        if (item.regex && !item.sku) {
            return false;
        }
        const refVendor = item.vendor;
        const refSku = item.regex ? undefined : item.sku;
        const itemMatches = data.some((item, currIdx) => {
            // if(item.regex) {
            //     if(idx !== currIdx && (item.vendor === refVendor)) {
            //         return true;
            //     }
            //     return false;
            // }
            if (idx !== currIdx && item.vendor === refVendor && item.sku === refSku) {
                return true;
            }
            return false;
        });
        if (itemMatches) {
            ctx._isTypesDataValid = false;
            item.isValid = false;
        } else {
            item.isValid = true;
        }
        return item.isValid;
    };

    let _validateGridData = function (data) {
        const invalidRows = [];
        data.forEach((item, idx) => {
            if (!_validateRowData(data, item, idx)) {
                ctx._slickTypesTable &&
                    ctx._slickTypesTable.getCellNode(idx, 0) &&
                    ctx._slickTypesTable
                        .getCellNode(idx, 0)
                        .closest(".slick-row")
                        .addClass("invalid");
                invalidRows.push(idx);
            } else {
                ctx._slickTypesTable &&
                    ctx._slickTypesTable.getCellNode(idx, 0) &&
                    ctx._slickTypesTable
                        .getCellNode(idx, 0)
                        .closest(".slick-row")
                        .removeClass("invalid");
            }
        });
        ctx._isTypesDataValid = !invalidRows.length;
        return ctx._isTypesDataValid;
    };

    ctx._validateTypesData = function () {
        if (!ctx._slickTypesDataView) {
            return true;
        }
        _validateGridData(ctx._slickTypesDataView.getItems());
        return ctx._isTypesDataValid;
    };

    ctx._setTypesData = function () {
        const typesData = {};
        const data = ctx._slickTypesDataView.getItems();
        typesData.mapping = ctx._formatTypesGridToMapping(data);
        typesData.createUnmapped = ctx._dtCreateUnmappedCheckbox.getValue();
        // console.log(typesData);
        ctx._setTypesDataToEty(typesData);
        ctx.emit("ValueChange");
        return true;
    };

    ctx._setTypesDataToEty = function (data) {
        const typesData = ctx.getTypeData() || {};
        typesData.createUnmapped = data.createUnmapped;
        typesData.mapping = data.mapping;
        const dataSyncMapping = ctx._dataSyncConfigEntity.getDataSyncMappings() || {};
        _.set(dataSyncMapping, "modelMapping.deviceTypes", typesData);
        ctx._dataSyncConfigEntity.setDataSyncMappings(dataSyncMapping);
    };

    ctx._onAddNewType = function () {
        // console.log("add type");
        const newRow = ctx._getTypeRow();
        const data = ctx._slickTypesDataView.getItems();
        data.push(newRow);
        ctx._resetTypeGrid(data);
        _validateGridData(data);
        ctx._setTypesData();
    };

    ctx._deleteType = function (id) {
        const deleteMessage = `Are you sure you want to delete the "Device Type Mapping"?`;
        return ctx
            ._deleteConfirmation(deleteMessage)
            .then(() => {
                ctx._slickTypesDataView.deleteItem(id);
                const data = ctx._slickTypesDataView.getItems();
                ctx._resetTypeGridView(data);
                _validateGridData(data);
                ctx._setTypesData();
            })
            .catch((error) => error && ctx._showError(error));
    };

    ctx._onTypesCellChangeAction = function (/*evt, args*/) {
        const data = ctx._slickTypesDataView.getItems();
        _validateGridData(data);
        ctx._setTypesData();
    }.bind(ctx);

    ctx._onTypesRowsChanged = function (/*evt, args*/) {
        const data = ctx._slickTypesDataView.getItems();
        _validateGridData(data);
        ctx._setTypesData();
    }.bind(ctx);
}

module.exports = createWithContext;
